import { useMutation } from "@tanstack/react-query";
import verificationService from "..";

function useCheckNationalCode() {
  return useMutation({
    mutationFn: verificationService.updateNationalCode,
  });
}

export default useCheckNationalCode;
